import styled from "styled-components";

export const Content = styled.div`

    .information {
        > p {
            font-size: 2.375rem;
            margin: 2rem 0;

            strong {
                color: #fe8418;
            }
        }
        > div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            img {
                max-width: 530px;
                width: 100%;
                height: 23rem;
                margin: 0.5rem;

                border-radius: 1.8rem;
            }

            p {
                max-width: 580px;
                max-height: 344px;
                width: 100%;
                height: 100%;

                margin: 2rem 0.7rem;
                font-size: 1.375rem;
            }
        }

        @media (max-width: 1024px){
           >div {
                img {
                    max-width: 500px;
                    width: 100%;
                    height: 23rem;
                 }

                p {
                    max-width: 540px;
                    width: 100%;
                    font-size: 1.2rem;
                }
           }
        }

        @media (max-width: 768px){
            >p {
                text-align:center;
            }
            >div {
               text-align:left;
               flex-direction: column;
                img {
                    margin: 0;
                 }

                p {
                    &:first-child {
                        margin-top: 2rem;
                    }
                }
           }
        }

        @media (max-width: 414px){

            >p {
                font-size: 2rem;
            }
           >div {
                img {
                    height: 14rem;
                 }

                p {
                   margin-right: 0;
                }
           }
        }
    }

    .details {
        display: flex;
        flex-direction: column;
        position: relative;

        margin: 3rem 0;

        > p {
            font-size: 2.375rem;
            margin: 2rem 0;

            strong {
                color: #fe8418;
            }

            &:before {
                content: "";
                width: 70%;
                height: 2px;
                background: #fe8418;
                position: absolute;
                top: 12.5%;
                right: 0%;
            }

            @media (max-width: 1024px){

                &:before {
                width: 65%;
                }
            }
            @media (max-width: 768px){

                &:before {
                width: 50%;
                top: 9%;
                right: 2%;
                }
            }

            @media (max-width: 414px){
                font-size: 2rem;
                &:before {
                    width: 20%;
                    top: 7%;
                    right: 2%;
                }
            }

            @media (max-width: 375px){

                &:before {
                    top: 6.7%;
                    width: 15%;
                }
            }

            @media (max-width: 360px){
                font-size: 1.7rem;
                &:before {
                    width: 20%;
                    top: 6.4%;
                }
            }

        }

        > div {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                max-width: 530px;
                max-height: 488px;
                margin-right: 0.5rem;
                border-radius: 20px;
                width: 100%;
                height: 28rem;
            }

            p {
                color: #fe8418;
                padding: 0.7rem 1.2rem;
                margin: 0.8rem 0.3rem;
                font-size:1.375rem;
                border: 1px solid #B7B7B7;
                border-radius: 1rem;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

                max-width: 580px;
                max-height: 344px;
                width: 100%;
                height: 100%;
            }

            @media (max-width:1024px){
                img {
                    max-width: 520px;
                }

                p {
                    max-width: 530px;
                    font-size:1.2rem;
                }
            }

            @media (max-width:768px){
                flex-direction: column;
                img {
                    height: 22rem;
                    margin: 1rem 0;
                }

                p {
                    max-width: 530px;
                    font-size:1.2rem;
                }
            }

            @media (max-width: 414px){
                img {
                    height: 14rem;
                    margin: 1rem 0;
                }

                p {
                    font-size: 1.2rem;
                    margin: 1rem 0;
                }
            }

        }
`;

export const CardContent = styled.div`
    display: none;7
    position:relative;

    .slick-arrow {
        width: 2rem;
        height: 2rem;

        :before {
            content: none;
        }
    }

    .slick-next {
        padding-left: 12px;
        padding-top: 8px;
        top: 106%;
        right: 10%;
    }

    .slick-prev {
        padding-left: 12px;
        padding-top: 8px;

        top: 106%;
        left: 10%;
    }

    .slick-dots {

        .slick-active {
            button {
                &:before {
                  color: orange;
                }
            }
        }

        li {

            button {
                &:before {
                    font-size:20px !important;
                }
            }
        }
    }

    @media (max-width: 600px) {
        display: block;
    }
`;
